/* eslint-disable no-template-curly-in-string */
/**
 * @file 编辑器扩展, 增加自定义组件
 */
import { BasePlugin, registerEditorPlugin } from 'amis-editor'

export class InfoGridPlugin extends BasePlugin {
  // 关联渲染器名字
  rendererName = 'com-pie-chart';
  $schema = '/schemas/UnkownSchema.json';
  notRenderFormZone = true;
  // 组件名称（组件面板显示的Title）
  name = '扇形图表';
  order=0; // 排序
  description = '扇形图表展示信息';
  tags = ['布局容器', 'A自定义'];
  icon = 'fa fa-file-code-o';
  scaffold = { // 插入到页面时需要
    'type': 'chart',
    'config': {
      'title': {
        'text': '设备接入类型'
      },
      'xAxis': {
        'show': false,
        'type': 'category',
        'data': [
          'Mon',
          'Tue',
          'Wed',
          'Thu',
          'Fri',
          'Sat',
          'Sun'
        ]
      },
      'tooltip': {
        'trigger': 'item'
      },
      'grid': {
        'left': 0,
        'right': '5px',
        'bottom': 0,
        'top': '8px',
        'backgroundColor': '#FFFFFF'
          // containLabel: false
      },
      'yAxis': {
        'type': 'value',
        'show': false
      },
      'series': [
        {
          'data': [
            820,
            932,
            901,
            934,
            1290,
            1330,
            1320
          ],
          'type': 'line'
        }
      ],
      'backgroundColor': 'transparent'
    },
    'replaceChartOption': true,
    'name': '设备接入类型',
    'style': {
      'boxShadow': ' 0px 0px 0px 0px transparent',
      'width': '100%',
      'height': '300px'
    },
    'label': '',
    'height': '90px',
    'dataFilter': "let sData = [{\r\n  name:'报警异常',\r\n  data:[\r\n    { value: 1048, name: 'Search Engine' },\r\n    { value: 735, name: 'Direct' },\r\n    { value: 580, name: 'Email' },\r\n    { value: 484, name: 'Union Ads' },\r\n    { value: 300, name: 'Video Ads' }\r\n  ]\r\n}];\r\nconfig.legend={\r\n  data:[],\r\n  orient:\"vertical\",\r\n  right:\"10%\",\r\n  top:\"10%\",\r\n};\r\nconfig.series = sData.map(item => {\r\n  item.data.forEach(itemD => {\r\n    config.legend.data.push(itemD.name);\r\n  })\r\n  return {\r\n    smooth: true,\r\n    type: 'pie',\r\n    radius: ['40%', '70%'],\r\n    center:['20%', '50%'],\r\n    label: {\r\n      show: false,\r\n      position: 'center'\r\n    },\r\n    name: item.name,\r\n    data: item.data,\r\n    // areaStyle: {\r\n    //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{\r\n    //       offset: 0,\r\n    //       color: '#520052C7'\r\n    //   }, {\r\n    //       offset: 1,\r\n    //       color: '#000052C7'\r\n    //   }])\r\n    // },\r\n    animationDuration: 2800,\r\n    animationEasing: 'cubicInOut'\r\n  }\r\n})"
  };
  previewSchema = { // 组件面板预览时需要
    'type': 'chart',
    'config': {
      'title': {
        'text': '设备接入类型'
      },
      'xAxis': {
        'show': false,
        'type': 'category',
        'data': [
          'Mon',
          'Tue',
          'Wed',
          'Thu',
          'Fri',
          'Sat',
          'Sun'
        ]
      },
      'tooltip': {
        'trigger': 'item'
      },
      'grid': {
        'left': 0,
        'right': '5px',
        'bottom': 0,
        'top': '8px',
        'backgroundColor': '#FFFFFF'
          // containLabel: false
      },
      'yAxis': {
        'type': 'value',
        'show': false
      },
      'series': [
        {
          'data': [
            820,
            932,
            901,
            934,
            1290,
            1330,
            1320
          ],
          'type': 'line'
        }
      ],
      'backgroundColor': 'transparent'
    },
    'replaceChartOption': true,
    'name': '设备接入类型',
    'style': {
      'boxShadow': ' 0px 0px 0px 0px transparent',
      'width': '100%',
      'height': '300px'
    },
    'label': '',
    'height': '90px',
    'dataFilter': "let sData = [{\r\n  name:'报警异常',\r\n  data:[\r\n    { value: 1048, name: 'Search Engine' },\r\n    { value: 735, name: 'Direct' },\r\n    { value: 580, name: 'Email' },\r\n    { value: 484, name: 'Union Ads' },\r\n    { value: 300, name: 'Video Ads' }\r\n  ]\r\n}];\r\nconfig.legend={\r\n  data:[],\r\n  orient:\"vertical\",\r\n  right:\"10%\",\r\n  top:\"10%\",\r\n};\r\nconfig.series = sData.map(item => {\r\n  item.data.forEach(itemD => {\r\n    config.legend.data.push(itemD.name);\r\n  })\r\n  return {\r\n    smooth: true,\r\n    type: 'pie',\r\n    radius: ['40%', '70%'],\r\n    center:['20%', '50%'],\r\n    label: {\r\n      show: false,\r\n      position: 'center'\r\n    },\r\n    name: item.name,\r\n    data: item.data,\r\n    // areaStyle: {\r\n    //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{\r\n    //       offset: 0,\r\n    //       color: '#520052C7'\r\n    //   }, {\r\n    //       offset: 1,\r\n    //       color: '#000052C7'\r\n    //   }])\r\n    // },\r\n    animationDuration: 2800,\r\n    animationEasing: 'cubicInOut'\r\n  }\r\n})"
  };

  // 容器类组件必需字段
  // regions = [
  //   {
  //     key: 'body',
  //     label: '内容区'
  //   }
  // ];

  panelTitle = '配置'; // 右侧属性面板Title

  panelControls = [ // 右侧属性面板配置项
    // {
    //   type: 'tabs',
    //   tabsMode: 'line',
    //   className: 'editor-prop-config-tabs',
    //   contentClassName: 'no-border editor-prop-config-tabs-cont hoverShowScrollBar',
    //   linksClassName: 'editor-prop-config-tabs-links aa',
    //   tabs: [
    //     {
    //       title: '常规',
    //       className: 'p-none',
    //       controls: [
    //         {
    //           'type': 'collapse-group',
    //           className: 'ae-formItemControl ae-styleControl',
    //           'activeKey': [
    //             'grid_11', 'grid_12'
    //           ],
    //           body: [
    //             {
    //               'type': 'collapse',
    //               'key': 'grid_11',
    //               'header': '基本',
    //               headingClassName: 'ae-formItemControl-header ae-Collapse-header',
    //               bodyClassName: 'ae-formItemControl-body',
    //               'body': [
    //                 {
    //                   type: 'input-text',
    //                   name: 'source_data',
    //                   label: '数据源',
    //                   value: 'deviceData',
    //                   // 'mode': 'inline',
    //                   'required': true

    //                 },
    //                 {
    //                   type: 'input-text',
    //                   name: 'grid_name',
    //                   label: '子设备名称',
    //                   value: 'deviceName',
    //                   // 'mode': 'inline',
    //                   'required': true
    //                 }
    //               ]
    //             },
    //             {
    //               'type': 'collapse',
    //               'key': 'grid_12',
    //               'header': '采集项',
    //               headingClassName: 'ae-formItemControl-header ae-Collapse-header',
    //               bodyClassName: 'ae-formItemControl-body',
    //               'body': [
    //                 {
    //                   type: 'input-text',
    //                   name: 'grid_child_data',
    //                   label: '采集项数据',
    //                   value: 'data',
    //                   'required': true

    //                 },
    //                 {
    //                   type: 'input-text',
    //                   name: 'grid_child_name',
    //                   label: '名称',
    //                   value: 'attrName',
    //                   // 'mode': 'inline',
    //                   'required': true
    //                 },
    //                 {
    //                   type: 'input-text',
    //                   name: 'grid_child_value',
    //                   label: '数值',
    //                   value: 'value',
    //                   // 'mode': 'inline',
    //                   'required': true
    //                 },
    //                 {
    //                   type: 'input-text',
    //                   name: 'grid_child_unit',
    //                   label: '单位',
    //                   value: 'attrUnit'
    //                   // 'mode': 'inline'
    //                 },
    //                 {
    //                   type: 'input-text',
    //                   name: 'grid_child_icon',
    //                   label: '图标',
    //                   value: 'icon'
    //                   // 'mode': 'inline'
    //                 }
    //               ]
    //             }
    //           ]
    //         }

    //       ]
    //     },
    //     {
    //       title: '外观',
    //       className: 'p-none',
    //       controls: [
    //         {
    //           'type': 'collapse-group',
    //           className: 'ae-formItemControl ae-styleControl',
    //           'activeKey': [
    //             'grid_21', 'grid_22', 'grid_23'
    //           ],
    //           'body': [
    //             {
    //               'type': 'collapse',
    //               'key': 'grid_21',
    //               'header': '行数量',
    //               headingClassName: 'ae-formItemControl-header ae-Collapse-header',
    //               bodyClassName: 'ae-formItemControl-body',
    //               'body': [
    //                 {
    //                   type: 'input-number',
    //                   name: 'grid_num',
    //                   label: '一行显示数量',
    //                   value: 5
    //                   // 'mode': 'inline'
    //                 }
    //               ]
    //             },
    //             {
    //               'type': 'collapse',
    //               'key': 'grid_22',
    //               'header': '显隐/排序设置',
    //               headingClassName: 'ae-formItemControl-header ae-Collapse-header',
    //               bodyClassName: 'ae-formItemControl-body',
    //               'body': [
    //                 {
    //                   'type': 'switch',
    //                   'label': '状态',
    //                   'option': '',
    //                   'name': 'grid_edit',
    //                   'falseValue': false,
    //                   'trueValue': true,
    //                   'value': true,
    //                   'onText': '启用',
    //                   'offText': '禁用'
    //                 },
    //                 {
    //                   'type': 'input-text',
    //                   'label': '显隐key',
    //                   'name': 'grid_check_key',
    //                   'value': 'attrId',
    //                   'hiddenOn': '${AND(!grid_edit)}'
    //                 }
    //               ]
    //             },
    //             {
    //               'type': 'collapse',
    //               'key': 'grid_23',
    //               'header': '间距',
    //               headingClassName: 'ae-formItemControl-header ae-Collapse-header',
    //               bodyClassName: 'ae-formItemControl-body',
    //               'body': [
    //                 {
    //                   type: 'input-number',
    //                   name: 'grid_margin_bottom',
    //                   label: '行间距',
    //                   value: 5
    //                   // 'mode': 'inline'
    //                 },
    //                 {
    //                   type: 'input-number',
    //                   name: 'grid_padding_top',
    //                   label: '上边距',
    //                   value: 10
    //                   // 'mode': 'inline'
    //                 },
    //                 {
    //                   type: 'input-number',
    //                   name: 'grid_padding_left',
    //                   label: '左边距',
    //                   value: 0
    //                   // 'mode': 'inline'
    //                 },
    //                 {
    //                   type: 'input-number',
    //                   name: 'grid_padding_bottom',
    //                   label: '下边距',
    //                   value: 10
    //                   // 'mode': 'inline'
    //                 },
    //                 {
    //                   type: 'input-number',
    //                   name: 'grid_padding_right',
    //                   label: '右边距',
    //                   value: 0
    //                   // 'mode': 'inline'
    //                 }
    //               ]
    //             },
    //             {
    //               'type': 'collapse',
    //               'key': 'grid_23',
    //               'header': '颜色',
    //               headingClassName: 'ae-formItemControl-header ae-Collapse-header',
    //               bodyClassName: 'ae-formItemControl-body',
    //               'body': [
    //                 {
    //                   'type': 'input-color',
    //                   'label': '背景色',
    //                   'name': 'grid_background',
    //                   'format': 'rgba',
    //                   'value': 'rgba(255, 255, 255, 0)',
    //                   'labelRemark': {
    //                     'icon': 'fa fa-question-circle',
    //                     'trigger': [
    //                       'hover'
    //                     ],
    //                     'className': 'Remark--warning',
    //                     'placement': 'top',
    //                     'content': '设置整个区域的背景色'
    //                   },
    //                   'allowCustomColor': true
    //                   // 'mode': 'inline'
    //                 },
    //                 {
    //                   'type': 'input-color',
    //                   'label': '名称颜色',
    //                   'name': 'grid_name_color',
    //                   'format': 'rgba',
    //                   'value': 'rgb(87, 93, 108, 1)',
    //                   'labelRemark': {
    //                     'icon': 'fa fa-question-circle',
    //                     'trigger': [
    //                       'hover'
    //                     ],
    //                     'className': 'Remark--warning',
    //                     'placement': 'top',
    //                     'content': '设置名称颜色'
    //                   },
    //                   'resetValue': 'rgb(87, 93, 108, 1)',
    //                   'allowCustomColor': true
    //                   // 'mode': 'inline'
    //                 },
    //                 {
    //                   'type': 'input-color',
    //                   'label': '数值颜色',
    //                   'name': 'grid_value_color',
    //                   'format': 'rgba',
    //                   'value': 'rgb(28, 31, 39, 1)',
    //                   'labelRemark': {
    //                     'icon': 'fa fa-question-circle',
    //                     'trigger': [
    //                       'hover'
    //                     ],
    //                     'className': 'Remark--warning',
    //                     'placement': 'top',
    //                     'content': '设置数值颜色'
    //                   },
    //                   'resetValue': 'rgb(28, 31, 39, 1)',
    //                   'allowCustomColor': true
    //                   // 'mode': 'inline'
    //                 }
    //               ]
    //             }
    //           ]
    //         }
    //       ]
    //     },
    //     {
    //       title: '阈值',
    //       className: 'p-none',
    //       controls: [
    //         {
    //           'type': 'collapse-group',
    //           className: 'ae-formItemControl ae-styleControl',
    //           'activeKey': [
    //             'grid_31', 'grid_32'
    //           ],
    //           'body': [
    //             {
    //               'type': 'collapse',
    //               'key': 'grid_31',
    //               'header': '阈值数据设置',
    //               headingClassName: 'ae-formItemControl-header ae-Collapse-header',
    //               bodyClassName: 'ae-formItemControl-body',
    //               'body': [
    //                 {
    //                   type: 'input-text',
    //                   name: 'grid_alarm_data',
    //                   label: '阈值数据',
    //                   value: 'threshold'
    //                   // 'mode': 'inline'
    //                 }
    //               ]
    //             },
    //             {
    //               'type': 'collapse',
    //               'key': 'grid_32',
    //               'header': '阈值显示设置',
    //               headingClassName: 'ae-formItemControl-header ae-Collapse-header',
    //               bodyClassName: 'ae-formItemControl-body',
    //               'body': [
    //                 {
    //                   type: 'input-text',
    //                   name: 'grid_alarm_max',
    //                   label: '对应最大值',
    //                   value: 'max'
    //                   // 'mode': 'inline'
    //                 },
    //                 {
    //                   type: 'input-text',
    //                   name: 'grid_alarm_min',
    //                   label: '对应最小值',
    //                   value: 'min'
    //                   // 'mode': 'inline'
    //                 },
    //                 {
    //                   'type': 'input-text',
    //                   'label': '对应显示颜色',
    //                   'name': 'grid_alarm_color',
    //                   value: 'color'
    //                 }
    //               ]
    //             }
    //           ]
    //         }
    //       ]
    //     }
    //   ]

    // }

  ];
}

registerEditorPlugin(InfoGridPlugin)
